import {
    provideHttpClient,
    withFetch,
    withInterceptors,
} from "@angular/common/http";
import {
    ApplicationConfig,
    importProvidersFrom,
    LOCALE_ID,
    provideZoneChangeDetection,
} from "@angular/core";
import {
    BrowserModule,
    provideClientHydration,
    withEventReplay,
} from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { provideRouter, withViewTransitions } from "@angular/router";
import { ApiModule } from "@malirang/api-client";
import { provideComponentConfig } from "@malirang/front-share";
import { environment } from "../env/env";
import { appRoutes } from "./app.routes";
import { HttpInterceptor } from "../libs/http-interceptor";
import { registerLocaleData } from "@angular/common";
import localeKo from "@angular/common/locales/ko";

registerLocaleData(localeKo);

export const appConfig: ApplicationConfig = {
    providers: [
        provideClientHydration(withEventReplay()),
        provideZoneChangeDetection({ eventCoalescing: true }),
        provideRouter(appRoutes, withViewTransitions()),
        { provide: LOCALE_ID, useValue: "ko" },
        provideHttpClient(withFetch(), withInterceptors([HttpInterceptor])),

        provideComponentConfig({
            button: {
                rounded: "xl",
            },
            badge: {
                rounded: "lg",
                size: "sm",
            },
            input: {
                rounded: "xl",
                size: "sm",
            },
            label: {},
        }),
        importProvidersFrom(
            BrowserModule,
            BrowserAnimationsModule,
            ApiModule.forRoot({
                rootUrl: environment.baseUrl,
            }),
        ),
    ],
};
